module.exports = __webpack_public_path__ + "img/icon_mine_order.15ea76b6.png";